module.exports = __webpack_public_path__ + "static/media/welcome_illustration.87ada4be.svg";